
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { mdiChevronRight } from '@mdi/js'
import { UserAttributes } from '@/types/models/user'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  props: {
    user: {
      type: Object as PropType<UserAttributes | undefined>,
      'default': () => (undefined),
    }
  },
  components: { BaseSvgIcon },
  setup() {
    const { t } = useI18n()

    return {
      t,
      mdiChevronRight
    }
  },
})
